import * as Sentry from '@sentry/react';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'babel-polyfill';
import Dotenv from 'dotenv';
import { Router } from 'react-router-dom';
import { registerLocale } from 'react-datepicker';
import frLocale from 'date-fns/locale/fr';

import { initializeTagManager } from 'utils/analytics/tagmanager';
import { store, history } from 'helpers';
import { uiActions } from 'actions/Ui';
import App from 'App.jsx';

import 'styles/assets/css/global-styles.css';
import 'styles/assets/css/iconStyle.css';

// REACT_APP_ENV = deployment target (staging | production). Falls back to NODE_ENV if not set.
const appEnv = process.env.REACT_APP_ENV || process.env.NODE_ENV;

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: appEnv,
  // Send events only in staging and production (not in development)
  enabled: (appEnv === 'staging' || appEnv === 'production') && !!process.env.REACT_APP_SENTRY_DSN,
  release: `commande-com-front@${process.env.REACT_APP_VERSION || '0.1.0'}`,
  tracesSampleRate: 0.1,
});

registerLocale('fr', frLocale);

Dotenv.config();

initializeTagManager();

// set a custom vh property equal to 1% of the innerHeight
// to prevent shift from mobile browser due to url bar
document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);

window.addEventListener('resize', () => {
  store.dispatch(uiActions.screenResize(window.innerWidth));
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
});

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={<p>Une erreur est survenue</p>}>
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
);
